document.addEventListener('DOMContentLoaded', () => {

    const filterDiv = document.querySelector(".bef-exposed-form");

    if (filterDiv) {

        const fieldsets = document.querySelectorAll('.fieldgroup.form-composite');

        fieldsets.forEach(fieldset => {
            // Create a down arrow SVG element
            const downArrowSVG = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            downArrowSVG.setAttribute("width", "16");
            downArrowSVG.setAttribute("height", "16");
            downArrowSVG.setAttribute("viewBox", "0 0 16 16");
            downArrowSVG.setAttribute("class", "down-arrow");
            downArrowSVG.innerHTML = '<path d="M4 6l4 4 4-4z" fill="currentColor"/>';

            // Append the SVG to the legend
            const legend = fieldset.querySelector('legend');
            if (legend) {
                legend.appendChild(downArrowSVG);
            }

            // Add click event listener to toggle the class on the fieldset-wrapper
            const fieldsetWrapper = fieldset.querySelector('.fieldset-wrapper');
            
            if (fieldsetWrapper) {
                fieldset.addEventListener('click', (event) => {
                    if (!fieldsetWrapper.contains(event.target)) {
                        fieldsetWrapper.classList.toggle('opened');

                        const svgElement = fieldset.querySelector("svg");
                        svgElement.classList.toggle("opened");
                    }
                });
            }
        });
    }
});
